export enum SurveyKeys {
  ADMISSIONS_INTAKE = 'intake',
  ADMISSIONS_NPS = 'admissions-nps',
  AIMS = 'aims',
  ARFID_KEY = 'arfid',
  AUDIT_KEY = 'audit_',
  BAS_KEY = 'bas',
  C_SSRS_LIFETIME_KEY = 'c_ssrs',
  C_SSRS_LR_SCREENER_KEY = 'c-ssrs-lr-short',
  C_SSRS_RECENT_SCREENER_KEY = 'c-ssrs-recent-short',
  C_SSRS_SINCE_LAST_CONTACT_KEY = 'c_ssrs_slc',
  C_SSRS_SLC_SCREENER_KEY = 'c-ssrs-slc-short',
  CET_KEY = 'cet',
  DISCHARGE_SUMMARY = 'pt_',
  DUDIT = 'dudit_',
  EARLY_RESPONSE_CHECK_IN_KEY = 'erc_',
  EDE_Q_KEY = 'ede-q',
  FNS_KEY = 'fns',
  GAD7_KEY = 'gad7',
  LETHAL_MEANS_KEY = 'lm_',
  MP_INTAKE_ASSESSMENT = 'mpi_',
  NIAAA_BSTAD_KEY = 'niaaaa_',
  NIAS_KEY = 'nias',
  NON_ARFID_KEY = 'non_arfid',
  NPS_KEY = 'nps',
  PARDI_ARQ_PARENT_KEY = 'pardiarqparent',
  PARDI_ARQ_SELF_KEY = 'pardiarqself',
  PATIENT_EXPERIENCE = 'pt-exp',
  PHQ9_KEY = 'phq9',
  POP = 'pop_',
  PSEA_KEY = 'psea',
  QUALITY_OF_LIFE_KEY = 'cia',
  SAFETY_PLAN_KEY = 'sp_',
  TREATMENT_UPDATE = 'tx_',
  PCL5_KEY = 'pcl_5',
}
